import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardContent,
  TextField,
  Box,
  Grid,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../../actions';

const StimulationProtocolTable = () => {
  const dispatch = useDispatch();
  const fmsData = useSelector(
    (state) => state.clinicalReducer.currentCycle.fmsData,
  );

  const fetData = useSelector(
    (state) => state.clinicalReducer.currentCycle.fetSheet,
  );
  const treatmentPlanData = useSelector(
    (state) => state.clinicalReducer.treatmentPlan,
  );
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`currentCycle.fmsData.${name}`, value));
  };

  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <Card sx={{ width: '100%', padding: 2 }}>
          <CardContent>
            {/* Stimulation Protocol Table */}
            <TableContainer component={Paper}>
              <Table aria-label="stimulation protocol table">
                <TableHead>
                  <TableRow>
                    <TableCell>Stimulation Protocol</TableCell>
                    {fmsData.stimulationProtocol.map((protocol, index) => (
                      <TableCell align="left" key={index}>
                        {protocol.checked ? protocol.label : ''}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Drug Used</TableCell>
                    {fetData.tableData.map((data, index) => (
                      <TableCell align="left" key={index}>
                        {index + 1}) {data[`dose${index + 1}`]}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>Total Stimulation Dose (IU)</TableCell>
                    <TableCell colSpan={fmsData.stimulationProtocol.length}>
                      {fmsData.tableData.length}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* Expected Follicles Table */}
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table aria-label="expected follicles table">
                <TableBody>
                  <TableRow>
                    <TableCell>Stimulation Response</TableCell>
                    <TableCell align="left">Good: L. Ovary</TableCell>
                    <TableCell align="left">Moderate: R. Ovary</TableCell>
                    <TableCell align="left">Poor:</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Expected follicles</TableCell>
                    <TableCell align="left">
                      L. Ovary {fmsData.tableData[0].leftOvary}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      R. Ovary {fmsData.tableData[0].rightOvary}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* Trigger Table */}
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table aria-label="trigger table">
                <TableHead>
                  <TableRow>
                    <TableCell>Trigger</TableCell>
                    <TableCell align="left">Drug</TableCell>
                    <TableCell align="left">Dose</TableCell>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Time</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fmsData.triggerTable.map((data, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>Trigger {index + 1}</TableCell>
                        <TableCell align="left">{data.medicine}</TableCell>
                        <TableCell align="left">{data.dose}</TableCell>
                        <TableCell align="left">
                          {fmsData.triggerDate}
                        </TableCell>
                        <TableCell align="left">
                          {fmsData.triggerTime}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow>
                    <TableCell>OPU</TableCell>
                    <TableCell align="left">Time:</TableCell>
                    <TableCell colSpan={2}>Date:</TableCell>
                    <TableCell colSpan={2}></TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell>Trigger</TableCell>
                    <TableCell align="left">
                      Drug: {fetData.tableData[0].dose1}
                    </TableCell>
                    <TableCell align="left">
                      Time: {fetData.triggerTime}
                    </TableCell>
                    <TableCell align="left">
                      Date: {fetData.triggerDate}
                    </TableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Cycle Plan Table */}
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table aria-label="cycle plan table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 700 }}>
                      Cycle Plan
                    </TableCell>
                    <TableCell align="left">
                      {treatmentPlanData.embryoTransferDetails}
                    </TableCell>
                    <TableCell style={{ fontWeight: 700 }}>
                      PGT-A/PGT-M
                    </TableCell>
                    <TableCell align="left">
                      {treatmentPlanData.embryoGeneticAnalysisPGTAChecked
                        ? 'PGT-A'
                        : ''}
                      {treatmentPlanData.embryoGeneticAnalysisPGTMChecked
                        ? 'PGT-M'
                        : ''}
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>

            {/* Comment, Sign, and Date Fields */}
            <Box sx={{ marginTop: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Comment"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    name="opuComment"
                    value={fmsData.opuComment}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={4}>
                  <TextField
                    label="Sign"
                    variant="outlined"
                    fullWidth
                    name="opuSign"
                    value={fmsData.opuSign}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={4}>
                  <TextField
                    label="Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    autoFocus={true}
                    name="opuSheetDate"
                    value={fmsData.opuSheetDate}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StimulationProtocolTable;
